import React from "react";
import { connect } from "react-redux";
import SelectAll from "./SelectAll";
import ShowGuides from "./ShowGuides";
import Zoom from "./Zoom";
import "./RightControls.css";

class RightControls extends React.Component {
  render() {
    const layers = this.props.layers;
    let deselectedTotal = 0;

    // Count number of selected elements
    layers.forEach((layer) => {
      ["text", "image"].forEach((type) => {
        if (layer["allow_" + type]) {
          deselectedTotal += layer[type + "_elements"].reduce(
            (total, element) => {
              return !element.is_selected ? total + 1 : total;
            },
            0,
          );
        }
      });
    });

    return (
      <div className="canvas-controls canvas-controls--right">
        <SelectAll totalDeselectedElements={deselectedTotal} />
        <ShowGuides
          onToggleGuides={this.props.onToggleGuides}
          guidesVisible={this.props.guidesVisible}
        />
        <Zoom handleZoom={this.props.handleZoom} />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    layers: state.design.present.layer_set,
  };
}

export default connect(mapStateToProps)(RightControls);
